<template>
  <comHeader></comHeader>
  <!-- inner banner -->
  <div class="inner-banner">
    <section class="w3l-breadcrumb">
      <div class="container">
        <h4 class="inner-text-title font-weight-bold text-white mb-sm-3 mb-2">
          My ID Tags
        </h4>
        <ul class="breadcrumbs-custom-path">
          <li><a href="/">Home</a></li>
          <li class="active">
            <span class="fa fa-chevron-right mx-2" aria-hidden="true"></span>My
            ID Tags
          </li>
        </ul>
      </div>
    </section>
  </div>
  <!-- //inner banner -->
  <section class="w3l-aboutblock py-5" v-if="!showList">
    <div class="container">
      <div class="login-page">
        <!-- 表单区域 -->
        <div class="form-container">
          <!-- 邮箱输入框 -->
          <div class="input-title">Email:</div>
          <div class="form-item">
            <div>
              <input
                class="input-field"
                type="email"
                @blur="validateEmail"
                placeholder="Enter email"
                v-model="email"
              />
            </div>
            <div style="color: red; font-size: 12px; clear: both">
              {{ errMsg }}
            </div>
          </div>
          <div class="input-title">Verification Code:</div>
          <div class="form-item">
            <div style="width: 100%; display: flex">
              <input
                class="input-field input-field-r-noradius input-field-code"
                placeholder="Enter code"
                v-model="verCode"
              />
              <div v-if="!showTimer" class="code" @click="getVeryfiedCode">
                <text>Get Code</text>
              </div>
              <div v-else class="timer">
                <text>{{ timer }} s</text>
              </div>
            </div>
            <div style="color: red; font-size: 12px; clear: both">
              {{ codeErrMsg }}
            </div>
          </div>

          <!-- 登录按钮 -->
          <div class="action-buttons login-btn">
            <button class="action-item action-item-phone" @click="handleLogin">
              Login
            </button>
          </div>
        </div>
        <div class="google-container">
          <div
            style="
              margin-top: auto;
              display: flex;
              flex-direction: column;
              align-items: flex-end;
            "
          >
            <div class="memo-text">
              <div>Not a member yet ?</div>
              <div>Sign up now!</div>
            </div>
            <!-- Google 登录按钮 -->
            <div class="action-buttons google-btn">
              <button
                id="googleLoginBtn"
                class="action-item action-item-google"
                @click="gotoGoogleLogin"
              >
                <img class="google-icon" src="@/assets/images/google.png" />
                Sign up with Google
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="w3l-aboutblock py-5" v-if="showList">
    <div class="list-container">
      <div v-for="(item, index) in itemList" :key="index" class="list-item">
        <div class="list-item-left">
          <!-- <img class="item-vatar" :src="'/static/images/'+item.petPhoto" alt=""/> -->
          <img
            class="item-avatar"
            :src="'/static/images/' + item.petPhoto"
            alt=""
          />
        </div>
        <div class="list-item-right list-item-right-left">
          <div class="item">
            <div class="item-icon">
              <img
                style="width: 100%; height: 100%"
                src="@/assets/images/catc.png"
                v-if="item.petType === 'cat'"
              />
              <img
                style="width: 100%; height: 100%"
                src="@/assets/images/dogc.png"
                v-else
              />
            </div>
            <div>PET NAME :</div>
            <div class="pl-2">{{ item.petName }}</div>
          </div>
          <div class="item">
            <div class="item-icon"></div>
            <div>BIRTHDAY :</div>
            <div class="pl-2">{{ item.petBirthDate?.slice(0, 10) }}</div>
          </div>
          <div class="item">
            <div class="item-icon"></div>
            <div>TYPE :</div>
            <div class="pl-2">{{ item.petType }}</div>
          </div>
          <div class="item">
            <div class="item-icon"></div>
            <div>BREED :</div>
            <div class="pl-2">{{ item.petCategory }}</div>
          </div>
          <div class="item">
            <div class="item-icon">
              <img
                style="width: 100%; height: 100%"
                src="@/assets/images/phonec.png"
              />
            </div>
            <div>TEL :</div>
            <div class="pl-2">{{ item.petPhone }}</div>
          </div>
          <div class="item">
            <div class="item-icon">
              <img
                style="width: 100%; height: 100%"
                src="@/assets/images/email.png"
              />
            </div>
            <div>EMAIL :</div>
            <div class="pl-2">{{ item.petMail }}</div>
          </div>
        </div>
      </div>
      <div class="more-container">
        <div class="qr-container">
            <div style="width:300px;height:300px;">
                <img src="@/assets/images/qrcode.png" style="width:100%;height: 100%;text-align: center;"/>
            </div>
            <div style="color:#8e0807;padding:10px;font-size: 24px;font-weight: 500;">
                Scan and Get More
            </div>
        </div>
        <div class="img-container" style="width:400px;height:400px;" :style="{ display:display }">
          <img src="@/assets/images/nolist.jpg" alt="" style="width:100%;height: 100%;text-align: center;" />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import comHeader from "@/components/comHeader.vue";
export default {
  name: "appIdTags",
  components: {
    comHeader,
  },
};
</script>
<script setup>
import { api, googleClientId } from "@/assets/js/requests.js";
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
const showList = ref(true);
const itemList = ref([]);
const verCode = ref("");
const email = ref("");
const timer = ref(120);
const errMsg = ref("");
const codeErrMsg = ref("");
const showTimer = ref(false);
const intervalId = ref(null);
const route = useRoute();
const display = ref('none');

onMounted(async () => {
  const { code, state } = route.query;
  const localState = localStorage.getItem("google_state");
  console.log("query:", route.query);
  console.log("state:", state);
  console.log("code:", code);
  if (code) {
    if(localState !== state){
      alert("Invalid Google sign in link.");
      return;
    }
    const res = await handleGoogleLogin(code);
  }
  await getPetTagList();
  if(!itemList.value || itemList.value.length <= 0){
    display.value = 'block';
  }
});

const getVeryfiedCode = () => {
  if (!email.value) {
    errMsg.value = "Please input email";
    return;
  }
  api.common.sendVerificationCode({ email: email.value }).then((res) => {
    if (res.data && res.data.code === 200) {
      alert("Verification code has been sent to your email box!");
      showTimer.value = true;
      intervalId.value = setInterval(() => {
        if (timer.value <= 0) {
          clearInterval(intervalId.value);
          timer.value = 120;
          showTimer.value = false;
          return;
        }
        timer.value--;
      }, 1000);
    }
  });
};

const getPetTagList = () => {
  const ownerId = localStorage.getItem("ownerId");
  const token = localStorage.getItem("token");
  if (!ownerId || !token) {
    showList.value = false;
    return;
  }
  return new Promise((resolve, reject) => {
    api.petTags
      .getPetTags(ownerId)
      .then((res) => {
        if (res.data.code === 401) {
          showList.value = false;
          reject(res.data.message);
          return;
        }
        if (res.data && res.data.rows.length > 0) {
          itemList.value = res.data.rows;
          resolve(res);
        }
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const handleLogin = () => {
  console.log("login");
  clearErrMsg();
  if (email.value === "") {
    errMsg.value = "Please input email";
    return;
  }
  if (verCode.value === "") {
    codeErrMsg.value = "Please input code";
    return;
  }

  api.user
    .login({
      code: verCode.value,
      email: email.value,
    })
    .then((res) => {
      console.log(res.data);
      clearInterval(intervalId.value);
      showTimer.value = false;
      if (res.data.code === 500) {
        codeErrMsg.value = res.data.message;
        return;
      }
      localStorage.setItem("token", res.data.data.token);
      localStorage.setItem("ownerId", res.data.data.ownerId);
      getPetTagList(res.data.data.ownerId)
      showList.value = true;
    })
    .catch((err) => {
      console.log(err);
    });
  console.log(itemList.value);
};

const gotoGoogleLogin = () => {
  const stateToken = Math.random().toString(36).substring(2, 15) +Math.random().toString(36).substring(2, 15);
  localStorage.setItem('google_state', stateToken);
  const redirectUri = encodeURIComponent(`${window.location.origin}/idtags`);
  const scope = encodeURIComponent('profile email');
  const googleAuthUrl = `https://accounts.google.com/o/oauth2/v2/auth?` +
    `response_type=code&` +
    `client_id=${googleClientId}&` +
    `redirect_uri=${redirectUri}&` +
    `scope=${scope}&` +
    `state=${stateToken}&` +
    `access_type=offline&` +
    `prompt=consent`;
  window.location.href = googleAuthUrl;
};

const handleGoogleLogin = (code) => {
  console.log("handleGoogleLogin");
  return new Promise((resolve, reject) => {
    api.user
      .googleLogin(code)
      .then((res) => {
        resolve(res.data);
        if (res.data.code === 500) {
          codeErrMsg.value = res.data.message;
          return;
        }
        localStorage.setItem("token", res.data.data.token);
        localStorage.setItem("ownerId", res.data.data.ownerId);
        getPetTagList(res.data.data.ownerId)
      })
      .catch((err) => {
        reject(err)
     });
  })
};

const clearErrMsg = () => {
  errMsg.value = "";
  codeErrMsg.value = "";
};
</script>
<style>
.login-page {
  display: flex;
  position: relative;
  min-height: 500px;
  padding: 20rpx;
  box-sizing: border-box;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
}

/* 表单容器 */
.form-container {
  display: flex;
  flex-direction: column;
  max-width: 800rpx;
  padding: 40rpx;
  height: 300px;
}

.input-title {
  font-size: 24px;
  color: #977f68;
  margin-bottom: 10px;
  margin-top: 20px;
}

.input-field::placeholder {
  color: #a79c93;
}

/* 表单项 */
.form-item {
  margin-bottom: 30rpx;
  display: flex;
  padding: 5px;
  flex-direction: column;
}

.input-field {
  height: 50px;
  width: 300px;
  line-height: 30px;
  padding: 0 20rpx 5rpx 20rpx;
  font-size: 18px;
  border: 1px solid #b0a28d;
  border-radius: 5px;
  padding-left: 5px;
}
.input-field-r-noradius {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-field-code {
  width: 200px;
}

.code {
  display: flex;
  height: 50rpx;
  width: 100px;
  color: #fff;
  font-size: 24rpx;
  font-weight: bold;
  justify-content: center;
  align-items: center;
  border-radius: 50rpx;
  padding: 5rpx;
  background: linear-gradient(to bottom, #f03b34 0%, #8e0807 100%);
}

.timer {
  display: flex;
  height: 50rpx;
  width: 60%;
  color: #fff;
  font-size: 24rpx;
  font-weight: bold;
  justify-content: center;
  align-items: center;
  border-radius: 50rpx;
  padding: 5rpx;
  background: linear-gradient(to bottom, #f03b34 0%, #8e0807 100%);
}

/* 登录按钮 */
.action-buttons {
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  margin-top: auto;
  padding: 10px 0;
  margin-right: 100px;
  font-size: 20px;
}

.login-btn {
  width: 50%;
  line-height: 40px;
}

.action-item {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  margin-bottom: 15rpx;
  border-radius: 60px;
  border: none;
  color: white;
  font-weight: bold;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  font-size: 40rpx;
}

button:active {
  border: none;
  outline: none;
}

button:focus {
  border: none;
  outline: 1px solid #fff;
}

.action-item-phone {
  background: linear-gradient(to bottom, #f03b34 0%, #8e0807 100%);
  /* 主渐变 */
}

.action-item-google {
  font-size: 32rpx;
  background: linear-gradient(to bottom, #d2c5b6 0%, #a18668 100%);
  margin-left: auto;
}

.text {
  padding: 0 20rpx;
  color: #999;
  font-size: 24rpx;
}

.google-container {
  display: flex;
  width: 500px;
  height: 320px;
  flex-direction: column;
  justify-content: right;
}

/* Google 登录按钮 */
.google-btn {
  width: 320px;
  line-height: 40px;
  color: #333;
  font-size: 28rpx;
  border-radius: 10rpx;
  display: flex;
  margin-bottom: 20rpx;
  justify-content: left;
  padding-left: 20px;
  margin-right: 0px;
}

.google-icon {
  width: 32px;
  height: 32px;
  margin-right: 20px;
}

.memo-text {
  display: flex;
  flex-direction: column;
  color: #8c0607;
  font-size: 32px;
  width: 300px;
  margin-top: auto;
  font-weight: 400;
  padding: 10px 0;
}

/* 用户协议文本 */
.terms-text {
  margin-top: 100rpx;
  text-align: center;
  color: #666;
  font-size: 24rpx;
  line-height: 1.5;
}

.terms-link {
  color: #a11210;
  text-decoration: underline;
}

.list-container {
  display: flex;
  gap: 10px; /* 可选，两块之间的间距 */
  flex-direction: column;
  align-items: center;
  max-width: 1020px;
  margin: auto;
}

.list-item {
  /* 关键：当只有一块时，margin: auto 会使其居中 */
  display: flex;
  margin: auto;
  /* width:1020px; */
  width: 100%;
  min-height: 300px;
  background-image: url("@/assets/images/login_bg.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  align-items: center;
  justify-content: center;
  background-position: center;
  box-shadow: 0 2px 10px rgba(212, 100, 100, 0.1);
  border-radius: 20px;
  flex-wrap: wrap;
}

.list-container:has(.list-item:nth-child(2)) .list-item {
  margin: 0;
}

.list-item-left,
.list-item-right {
  display: flex;
  flex-direction: column;
  min-width: 50%;
  height: 100%;
  padding: 10px;
  align-items: center;
}

.list-item-right-left {
  padding-left: 20px;
  align-items: flex-start;
  font-size: 20px;
  font-weight: 500;
  color: #a11210;
}

.item-avatar {
  display: flex;
  width: 250px;
  height: 250px;
  border-radius: 50%;
  margin: auto 0;
}

.item {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
}
.item-icon {
  width: 40px;
  height: 40px;
  display: flex;
  padding: 10px;
}

.qr-container{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border-radius: 20px;
    padding:20px;
    background-color: #D5CAB4;
    margin-top:20px;
    width:400px;
    height: 400px;
    
}

.more-container{
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: center;
}

.img-container {
  display:flex;
  margin-left: auto;

}
</style>
